/* eslint-disable prettier/prettier */
import React from 'react';
import styles from '../../../../styles/components/pageComponents/coach/ResourceModal.module.css';

export interface ResourceFile {
	id: string;
	name: string;
	file: File;
	visibility: boolean;
	downloadable: boolean;
}

interface ResourceModalProps {
	title?: string;
	filesLabel?: string;
	visibilityLabel?: string;
	downloadableLabel?: string;
	addFileLabel?: string;
	submitButtonText?: string;
	files: ResourceFile[];
	onClose: () => void;
	onAddFile: () => void;
	onDeleteFile: (id: string) => void;
	onToggleVisibility: (id: string) => void;
	onToggleDownloadable: (id: string) => void;
	onSubmit: () => void;
}

const ResourceModal: React.FC<ResourceModalProps> = ({
	title = 'Add Resources',
	filesLabel = 'Files',
	visibilityLabel = 'Visibility',
	downloadableLabel = 'Downloadable',
	addFileLabel = 'Add File',
	submitButtonText = 'Add Resources',
	files,
	onClose,
	onAddFile,
	onDeleteFile,
	onToggleVisibility,
	onToggleDownloadable,
	onSubmit,
}) => {
	return (
		<div className={styles.overlay}>
			<div className={styles.modalContainer}>
				{/* Header */}
				<div className={styles.header}>
					<h2 className={styles.title}>{title}</h2>
					<button
						className={styles.closeButton}
						onClick={onClose}
						aria-label="Close"
					>
						&times;
					</button>
				</div>

				{/* Table Header */}
				<div className={styles.tableHeader}>
					<span className={styles.colFiles}>{filesLabel}</span>
					<span className={styles.colVisibility}>
						{visibilityLabel}
					</span>
					<span className={styles.colDownload}>
						{downloadableLabel}
					</span>
					<span className={styles.colAction}></span>
				</div>

				{/* File List */}
				<div className={styles.fileList}>
					{files.map(file => (
						<div key={file.id} className={styles.fileRow}>
							<div className={styles.colFiles}>
								<span className={styles.fileName}>
									{file.name}
								</span>
							</div>
							<div className={styles.colVisibility}>
								<input
									type="checkbox"
									checked={file.visibility}
									onChange={() => onToggleVisibility(file.id)}
									className={styles.checkbox}
								/>
							</div>
							<div className={styles.colDownload}>
								<input
									type="checkbox"
									checked={file.downloadable}
									onChange={() =>
										onToggleDownloadable(file.id)
									}
									className={styles.checkbox}
								/>
							</div>
							<div className={styles.colAction}>
								<button
									className={styles.deleteButton}
									onClick={() => onDeleteFile(file.id)}
									title="Delete"
								>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="20"
										height="22"
										viewBox="0 0 20 22"
										fill="none"
									>
										<path
											d="M7.75 9.75V15.75M11.75 9.75V15.75M16.75 4.75V18.75C16.75 19.2804 16.5393 19.7891 16.1642 20.1642C15.7891 20.5393 15.2804 20.75 14.75 20.75H4.75C4.21957 20.75 3.71086 20.5393 3.33579 20.1642C2.96071 19.7891 2.75 19.2804 2.75 18.75V4.75M0.75 4.75H18.75M5.75 4.75V2.75C5.75 2.21957 5.96071 1.71086 6.33579 1.33579C6.71086 0.960714 7.21957 0.75 7.75 0.75H11.75C12.2804 0.75 12.7891 0.960714 13.1642 1.33579C13.5393 1.71086 13.75 2.21957 13.75 2.75V4.75"
											stroke="#1E1E1E"
											stroke-width="1.5"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
									</svg>
								</button>
							</div>
						</div>
					))}
				</div>

				{/* Footer Actions */}
				<div className={styles.footer}>
					<button className={styles.addFileBtn} onClick={onAddFile}>
						<span className={styles.plusIcon}>+</span>{' '}
						{addFileLabel}
					</button>
					<div className={styles.divider}></div>
					<button className={styles.submitBtn} onClick={onSubmit}>
						{submitButtonText}
					</button>
				</div>
			</div>
		</div>
	);
};

export default ResourceModal;
